<div mat-dialog-content>
    <p>{{message}}</p>
</div>